import {emptyValidator, formValidator} from "../../validators";

const clusterValidationStatus = {

    clnCluster: {
        validators: [emptyValidator()],
        name: "Cluster Name"
    },
    clnDescription: {
        validators: [emptyValidator()],
        name: "Cluster Description"
    },
};
export const clusterValidation = (cluster) => {
    return formValidator(cluster, clusterValidationStatus);
}
